module.exports = __webpack_public_path__ + "static/media/greetingCards.7a55386a.jpg";